module.exports = __webpack_public_path__ + "img/carrierboard2.84aea0e7.png";